import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/data';
import './SupportWidget.css';

const supportIconDataUri = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDMwIDMwIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMy44NjQgMTAuNTJDNS42MzkgNi4xMTMgOS45NTYgMyAxNSAzczkuMzYgMy4xMTIgMTEuMTM2IDcuNTJhNCA0IDAgMCAwLS40MjItLjAyIDMuMjE0IDMuMjE0IDAgMCAwLTMuMjE0IDMuMjE0djUuNTcyYzAgMS4zNi44NDYgMi41MjQgMi4wNCAyLjk5M2ExMi4wMyAxMi4wMyAwIDAgMS01LjE1NSAzLjg5NUEzIDMgMCAwIDAgMTYuNSAyNGgtM2EzIDMgMCAwIDAgMCA2aDEuNTA1QzIzLjI4NyAyOS45OTcgMzAgMjMuMjgzIDMwIDE1UzIzLjI4NCAwIDE1IDBDNy42NTQgMCAxLjU0MiA1LjI4LjI1MSAxMi4yNTMuMDg2IDEzLjE0MyAwIDE0LjA2MiAwIDE1YzAgMS43NTcuMzAyIDMuNDQyLjg1NyA1LjAwOS4zMzUuOTQ4LjkzNyAxLjgzNSAxLjg3NCAyLjIuNDgyLjE4OCAxLjAwNi4yOTEgMS41NTUuMjkxQTMuMjE0IDMuMjE0IDAgMCAwIDcuNSAxOS4yODZ2LTUuNTcyQTMuMjE0IDMuMjE0IDAgMCAwIDQuMjg2IDEwLjVxLS4yMTQgMC0uNDIyLjAyIi8+PC9zdmc+';

const initialForm = {
  fullName: '',
  phone: '',
  email: ''
};

const SupportWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (widgetRef.current && !widgetRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }

    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;
    const digitsOnly = value.replace(/\D/g, '');
    const limitedDigits = digitsOnly.slice(0, 10);

    if (limitedDigits.length > 0) {
      value = limitedDigits.replace(/(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/, (_, p1, p2, p3, p4) => {
        let result = p1;
        if (p2) result += ` ${p2}`;
        if (p3) result += ` ${p3}`;
        if (p4) result += ` ${p4}`;
        return result;
      });
    } else {
      value = '';
    }

    setFormData((prev) => ({ ...prev, phone: value }));

    if (errors.phone) {
      setErrors((prev) => ({ ...prev, phone: '' }));
    }

    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Введите ФИО';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Введите номер телефона';
    } else {
      const phoneDigits = formData.phone.replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        newErrors.phone = 'Введите полный номер телефона';
      }
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Введите email';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Введите корректный email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    setErrors({});
    setSuccessMessage('');

    try {
      const response = await axios.post(
        `${API_URL}/api/contact/callback`,
        {
          fullName: formData.fullName.trim(),
          phone: formData.phone.trim(),
          email: formData.email.trim()
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        setSuccessMessage('Заявка отправлена. Мы скоро свяжемся с вами.');
        setFormData(initialForm);
      }
    } catch (error) {
      if (error.response?.data?.message) {
        setErrors({ general: error.response.data.message });
      } else if (error.request) {
        setErrors({ general: 'Ошибка сети. Проверьте интернет.' });
      } else {
        setErrors({ general: 'Произошла ошибка. Попробуйте позже.' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleTelegram = () => {
    window.open('https://t.me/ProTop01123', '_blank');
  };

  return (
    <div className="support-widget" ref={widgetRef}>
      {isOpen && (
        <div className="support-widget__panel">
          <div className="support-widget__panel-title">Свяжитесь с нами</div>

          <form className="support-widget__form" onSubmit={handleSubmit}>
            {errors.general && <div className="support-widget__error-general">{errors.general}</div>}
            {successMessage && <div className="support-widget__success">{successMessage}</div>}

            <div className="support-widget__field">
              <input
                required
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="ФИО"
                className={`support-widget__input ${errors.fullName ? 'support-widget__input--error' : ''}`}
              />
              {errors.fullName && <div className="support-widget__error-text">{errors.fullName}</div>}
            </div>

            <div className="support-widget__field">
              <div className="support-widget__phone-wrap">
                <span className="support-widget__country-code">+7</span>
                <input
                  required
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  placeholder="999 999 99 99"
                  className={`support-widget__phone-input ${errors.phone ? 'support-widget__input--error' : ''}`}
                />
              </div>
              {errors.phone && <div className="support-widget__error-text">{errors.phone}</div>}
            </div>

            <div className="support-widget__field">
              <input
                required
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
                className={`support-widget__input ${errors.email ? 'support-widget__input--error' : ''}`}
              />
              {errors.email && <div className="support-widget__error-text">{errors.email}</div>}
            </div>

            <div className="support-widget__actions">
              <button type="submit" className="support-widget__btn support-widget__btn--primary" disabled={isLoading}>
                {isLoading ? 'Отправляем...' : 'Заказать звонок'}
              </button>
              <button type="button" className="support-widget__btn support-widget__btn--ghost" onClick={handleTelegram}>
                Телеграм
              </button>
            </div>
          </form>
        </div>
      )}

      <button
        type="button"
        className="support-widget__fab"
        aria-label="Открыть форму поддержки"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={supportIconDataUri} alt="" className="support-widget__icon-image" />
      </button>
    </div>
  );
};

export default SupportWidget;
